/**
 * Runtime Config Button
 *
 * Trigger button + RuntimeConfigDialog pairing, extracted so FeatureTable
 * and ProjectFeatureManager only need to render one element per row instead
 * of managing dialog open state themselves (keeps those files under the
 * 200-line component cap).
 */

import { useState, type ReactElement } from 'react';
import { RuntimeConfigDialog } from './RuntimeConfigDialog';

interface RuntimeConfigButtonProps {
  featureId: string;
  featureName: string;
  projectId?: string;
  projectName?: string;
  packId?: string;
  packName?: string;
  className?: string;
  /** A required value is unset here: highlight where the fix is. */
  needsAttention?: boolean;
}

export function RuntimeConfigButton({
  featureId,
  featureName,
  projectId,
  projectName,
  packId,
  packName,
  className,
  needsAttention = false,
}: RuntimeConfigButtonProps): ReactElement {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`${className ?? 'feature-table__edit-btn'}${needsAttention ? ' runtime-config-btn--attention' : ''}`}
        onClick={() => { setOpen(true); }}
        aria-label={`Runtime config for ${featureName}${needsAttention ? ' (required value not set)' : ''}`}
      >
        Runtime Config
      </button>
      <RuntimeConfigDialog
        open={open}
        featureId={featureId}
        featureName={featureName}
        {...(projectId ? { projectId } : {})}
        {...(projectName ? { projectName } : {})}
        {...(packId ? { packId } : {})}
        {...(packName ? { packName } : {})}
        onClose={() => { setOpen(false); }}
      />
    </>
  );
}
